import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { logout, update_password } from "../../store/Slice/authSlice";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import authService from "../../Services/auth.service";

export default function UpdatePassword({
  title,
  passwordExpire,
  open,
  handleClose,
}) {
  const auth = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const schema = Yup.object().shape({
    password: Yup.string()
      .required("ระบุ Password ใหม่")
      .min(8, "รหัสผ่านต้องมากกว่า 8 ตัว"),
    password_confirm: Yup.string()
      .required("ระบุ Confirm Password ใหม่")
      .oneOf([Yup.ref("password"), null], "รหัสผ่านไม่ตรงกัน"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      password_confirm: "",
    },
    validationSchema: schema,
    onSubmit: (values, { resetForm }) => {
      // console.log(values);
      dispatch(update_password(values))
        .unwrap()
        .then((data) => {
          if (data.status === true) {
            resetForm();
            if (passwordExpire) {
              dispatch(logout())
                .unwrap()
                .then(() => {
                  navigate("/");
                });
            } else {
              handleClose();
            }
          }
        });
    },
  });
  // BOtjY0Lx
  const [password, setPassword] = useState("");

  const generatePassword = () => {
    let charset =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let newPassword = "";
    for (let i = 0; i < 8; i++) {
      newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
    }

    setPassword(newPassword);
    formik.setFieldValue("password", newPassword);
  };
  const closeGeneratePassword = () => {
    setPassword("");
    formik.setFieldValue("password", "");
  };

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle id="alert-dialog-title">
            {title ? title : "Update Password"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Your new password must be different from previously used passwords
            </DialogContentText>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
              mt={1}
            >
              <Grid item xs={12} md={12}>
                <Paper variant="outlined">
                  {password && (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          mt: 2,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: "bold" }}
                          component={"p"}
                        >
                          รหัสผ่านของคุณ :
                        </Typography>
                      </Box>
                      <Paper
                        variant="outlined"
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          bgcolor: "#e7e7e7",
                          m: 2,
                          height: 45,
                        }}
                      >
                        <Typography variant="h6">{password}</Typography>
                      </Paper>
                    </>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      m: 2,
                    }}
                  >
                    <Button
                      sx={{ mr: 1 }}
                      size="small"
                      onClick={generatePassword}
                      variant="contained"
                      color="secondary"
                    >
                      Generate Auto
                    </Button>
                    {password && (
                      <Button
                        size="small"
                        onClick={closeGeneratePassword}
                        variant="contained"
                        color="error"
                      >
                        ปิด
                      </Button>
                    )}
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="password"
                  name="password"
                  label="Password"
                  type="password"
                  variant="outlined"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.password)}
                  helperText={
                    formik.errors.password
                      ? formik.errors.password
                      : "รหัสผ่านต้องมากกว่า 8 ตัว"
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="password_confirm"
                  name="password_confirm"
                  label="Confirm Password"
                  type="password"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.password_confirm)}
                  helperText={formik.errors.password_confirm || " "}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <LoadingButton
              loading={auth.updatePasswordLoading}
              variant="contained"
              type="submit"
              startIcon={<SaveAltIcon />}
              autoFocus
              color="primary"
            >
              อัพเดท
            </LoadingButton>
            {passwordExpire ? (
              <Button
                color="error"
                variant="contained"
                startIcon={<LogoutIcon />}
                onClick={() => {
                  dispatch(logout())
                    .unwrap()
                    .then(() => {
                      navigate("/");
                    });
                }}
              >
                Log Out
              </Button>
            ) : (
              <Button
                startIcon={<CloseIcon />}
                color="error"
                onClick={handleClose}
              >
                ยกเลิก
              </Button>
            )}
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
